<!-- Snackbar.vue -->
<template>
  <div class="snackbar-container">
    <TransitionGroup name="notification">
      <div
        v-for="notification in notifications"
        :key="notification.id"
        class="notification"
        :class="[
          notification.type === 'success' && 'notification--success',
          notification.type === 'error' && 'notification--error',
          notification.type === 'warning' && 'notification--warning',
          notification.type === 'info' && 'notification--info'
        ]"
      >
        <span>{{ notification.message }}</span>
        <button
          class="notification__close"
          @click="removeNotification(notification.id)"
        >
          <svg
            class="notification__close-icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import { useNotificationsStore } from '@/stores/notifications'
import { storeToRefs } from 'pinia'

const notificationsStore = useNotificationsStore()
const { notifications } = storeToRefs(notificationsStore)
const { removeNotification } = notificationsStore
</script>

<style scoped>
.snackbar-container {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  pointer-events: none;
}

.notification {
  pointer-events: auto;
  min-width: 300px;
  padding: 1rem;
  border-radius: 0.5rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.notification--success {
  background-color: var(--success);
}

.notification--error {
  background-color: var(--error);
}

.notification--warning {
  background-color: var(--warning);
}

.notification--info {
  background-color: var(--info);
}

.notification__close {
  background: none;
  border: none;
  padding: 0.25rem;
  margin-left: 1rem;
  cursor: pointer;
  color: currentColor;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.notification__close:hover {
  opacity: 1;
}

.notification__close-icon {
  width: 1rem;
  height: 1rem;
}

.notification-enter-active,
.notification-leave-active {
  transition: all 0.3s ease;
}

.notification-enter-from,
.notification-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
